export const FormSamplesNoFeedbackPageInfo = () => {
    return (
        <>
            If you don't want to show the green ticks after an input control is changed,
            you can do the following
            <ul>
                <li>Add a noFeedback prop to the formItem component for individual no feedbacks.</li>
                <li>For an entire form you can jus add the noFeedbackForm prop to the Form Component, like what this example does.</li>
            </ul>
            NOTE! Not all controls provide a green tick for feedback.
        </>
    )
}
